import React from "react";
import { useParams } from "react-router";
import PdfViewer from "../../PdfViewer";
import MallabhumPrayas from "../../MallabhumPrayas";

const MediaCoverageView = () => {
  const { pdfName } = useParams();
  if (!pdfName) {
    return null;
  }
  const pdfFile = `assets/pdf/${pdfName}.pdf`;
  return (
    <div>
      <div>
        <h1
          style={{
            fontSize: "36px",
            fontWeight: "bold",
            backgroundColor: "#2d662f",
            color: "#fff",
            textAlign: "center",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
            letterSpacing: "1.5px",
            fontFamily: "'Arial', sans-serif",
            padding: "10px 20px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MallabhumPrayas style={{ marginRight: "10px" }} />
          Media Coverage
        </h1>
      </div>
      <PdfViewer pdfFile={pdfFile} />
    </div>
  );
};

export default MediaCoverageView;
